import { useState } from "react";

import "modules/BrandsDashboard/BrandsDashboard.scss";
import { BrandsDashboardFilters, BrandsDashboardTable } from "modules/BrandsDashboard/components";

export const BrandsDashboard = () => {
  const [selectedVinPrefixes, setSelectedVinPrefixes] = useState<string[]>([]);

  return (
    <div className="BrandsDashboard">
      <BrandsDashboardFilters selectedVinPrefixes={selectedVinPrefixes} onFilterChange={setSelectedVinPrefixes} />
      <BrandsDashboardTable selectedVinPrefixes={selectedVinPrefixes} />
    </div>
  );
};
